/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-09, 10:34:04
 * Author: Michał Rejman <michal.rejman@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-02-23, 14:43:53
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const SET_SMS_CODE = 'SUBMIT_SMS_CODE';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const UNDO_LOGIN_STATE = 'UNDO_LOGIN_STATE';
export const TOGGLE_LOGIN_LOADING = 'TOGGLE_LOGIN_LOADING';
export const SET_SUBSCRIBER_MAIN_DATA = 'SET_SUBSCRIBER_MAIN_DATA';
export const SET_SUBSCRIBER_SETTINGS = 'SET_SUBSCRIBER_SETTINGS';
export const SET_SUBSCRIBER_ACL_FOR_GROUPS_OF_NUMBERS = 'SET_SUBSCRIBER_ACL_FOR_GROUPS_OF_NUMBERS';
export const CONFIRM_CHANGE_PASSWORD = 'CONFIRM_CHANGE_PASSWORD';



// WEBPACK FOOTER //
// ./src/store/modules/Subscriber/mutation-types.js